import { getMessagingIfSupported, getToken } from '@/lib/firebase-config';
import { isServiceWorkerSupported } from '@/utils/serviceWorkerSupport';

export const requestNotificationPermission = async (): Promise<string | null> => {
  try {
    const messaging = await getMessagingIfSupported();
    if (!messaging) {
      console.log('Messaging not supported in this environment');
      return null;
    }

    // Verifica se service workers são suportados antes de prosseguir
    if (!isServiceWorkerSupported()) {
      console.warn('Service Workers not supported in this browser');
      return null;
    }

    // Safari no iOS fora de PWA tem service worker mas não tem Notification.
    if (typeof Notification === 'undefined') {
      console.warn('Notification API not available in this browser');
      return null;
    }

    const vapidKey = process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY;
    if (!vapidKey) {
      console.error('[FCM] NEXT_PUBLIC_FIREBASE_VAPID_KEY is not configured');
      return null;
    }

    // Request notification permission
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      console.log('Notification permission granted.');

      // Register service worker manually
      // isServiceWorkerSupported() já garante que navigator.serviceWorker existe e é válido
      try {
        // Reusar SW existente para evitar conflito com registro interno do Firebase SDK
        let registration: ServiceWorkerRegistration;
        const existingRegistrations = await navigator.serviceWorker!.getRegistrations();
        const existingFcmSw = existingRegistrations.find((reg) =>
          reg.active?.scriptURL.includes('firebase-messaging-sw.js')
        );

        if (existingFcmSw) {
          registration = existingFcmSw;
          console.log('Reusing existing FCM Service Worker:', registration);
        } else {
          registration = await navigator.serviceWorker!.register('/firebase-messaging-sw.js');
          console.log('Service Worker registered successfully:', registration);
        }

        // Wait for service worker to be ready
        await navigator.serviceWorker!.ready;

        const token = await getToken(messaging, {
          vapidKey,
          serviceWorkerRegistration: registration,
        });

        if (token) {
          // console.log('Registration token:', token);
          return token;
        } else {
          // console.log('No registration token available.');
          return null;
        }
      } catch (swError) {
        console.error('Service Worker registration failed:', swError);
        return null;
      }
    } else {
      console.log('Unable to get permission to notify.');
      return null;
    }
  } catch (error) {
    console.error('An error occurred while retrieving token:', error);
    return null;
  }
};
